import { Typography } from "@mui/material";
import { ConfirmDialog } from "@avenue-8/sidekick-ui";
import { SIDEKICK_SUPPORT_EMAIL } from "@shared/utils/constants";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const SupportConfirmDialog = ({ open, onClose }: Props) => (
  <ConfirmDialog
    open={open}
    dialogTitle="Need help?"
    onConfirm={onClose}
    onClose={onClose}
    dialogContent={
      <div>
        <Typography>
          If you&apos;re having trouble signing up or signing in, reach out
          to our support team and we&apos;ll help you get set up:
        </Typography>
        <Typography mt={1}>
          <a href={`mailto:${SIDEKICK_SUPPORT_EMAIL}`}>
            {SIDEKICK_SUPPORT_EMAIL}
          </a>
        </Typography>
      </div>
    }
    confirmLabel="Ok"
  />
);
